
interface EmptyStateCTAProps {
  onClick: () => void
}

export default function EmptyStateCTA({ onClick }: EmptyStateCTAProps) {
  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center pointer-events-none">
      <button
        onClick={onClick}
        className="pointer-events-auto flex flex-col items-center justify-center gap-3 hover:opacity-80 transition-opacity"
      >
        <div className="border-2 border-dashed border-muted-foreground/25 rounded-lg w-24 h-24 flex items-center justify-center">
          <span className="text-4xl text-muted-foreground/40">+</span>
        </div>
        <p className="text-sm text-muted-foreground">Add first step...</p>
      </button>
    </div>
  )
}
